import { Processing, useIntl } from '@capsicum/common';
import { Button, Image } from '@capsicum/common-web';
import styled from 'styled-components';

export type ProcessingModalProps = {
	close: () => void;
	hideCloseButton?: boolean;
	testID: string;
};

export const ProcessingModal = ({ close, hideCloseButton, testID }: ProcessingModalProps) => {
	const { $t } = useIntl();

	return (
		<S.Wrapper data-testid={testID}>
			<S.ImageWrapper>
				<Image alt="kyc-sent-email" src={Processing} width={150} />
			</S.ImageWrapper>
			<S.TextWrapper>
				<S.Title>{$t('personalVerification.title')}</S.Title>
				<S.Description>{$t('personalVerification.message')}</S.Description>
			</S.TextWrapper>
			{!hideCloseButton && (
				<S.ButtonWrapper>
					<Button fullWidth testID="processing-modal-close" text={$t('global.close')} onClick={close} />
				</S.ButtonWrapper>
			)}
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled.div`
		height: 100%;
		width: 100%;
	`;

	export const ImageWrapper = styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: ${({ theme }) => theme.spacings.small};
	`;

	export const StyledImage = styled(Image)`
		max-height: 164px;
		height: auto;
		max-width: 263px;
		width: auto;
	`;

	export const TextWrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const Title = styled.p`
		${({ theme }) => theme.fonts.headings.title6};
		text-align: center;
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const Description = styled.p`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		text-align: center;
		margin-top: ${({ theme }) => theme.spacings.xsmall};
		margin: 0;
	`;

	export const ButtonWrapper = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-top: ${({ theme }) => theme.spacings.large};
		gap: ${({ theme }) => theme.spacings.small};
	`;
}
